import React, { useContext } from 'react'
import Link from '../Nav/Link'
import BackButton from '../Nav/BackButton'
import Title from '../Nav/Title'
import SelectAPattern from '../Nav/SelectAPattern'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import useMultilineText from '../hooks/useMultilineText'
import { EasybakeContext } from '../EasybakeProvider'

import patternPink from '../../asset/smartobject/smartobject_pattern_pink.png'
import patternScratch from '../../asset/smartobject/smartobject_pattern_scratch.png'
import patternCircles from '../../asset/smartobject/smartobject_pattern_circles.png'

export default function NavSmartObject () {
    const patterns = [
        { url: patternPink, action: 'pink' },
        { url: patternScratch, action: 'scratch' },
        { url: patternCircles, action: 'circles' }
    ]
    const { page } = useContext(EasybakeContext)
    const summary = useMultilineText(__('smartobject_nav_summary'))
    return (
        <div className="adobe-easybake-nav feature">
            <BackButton className="adobe-easybake-nav-back-button"/>
            <div className="adobe-easybake-nav-content">
                <Title title={__('smartobject_nav_title')} />
                <div className="summary">
                    {summary}
                </div>
                <Link className="adobe-easybake-nav-link" referrer={`documentation:${page}:nav`} label={__('link_doc')} url={__('url_doc_smartobject')} />
                <div className="adobe-easybake-nav-actions">
                    <SelectAPattern group="smartobject" patterns={patterns}/>
                </div>
            </div>
        </div>
    )
}
